import React, { useState } from 'react'
import ExperienceItem from './ExperienceItem'
import SideBar from './SideBar'

const eData = [
    {
        id: 7,
        extra: false,
        title: 'Software Developer',
        company: 'Ericsson',
        started: 'Jan 2026',
        isCompleted: false,
        ended: null,
        location: 'Ottawa, ON, Canada',
        workType: 'Full-Time',
        tags: ['Ottawa', 'Canada', 'Hybrid'],
        tech: ['C', 'Linux', 'Yocto', 'Git', 'CI/CD', 'Bash'],
        responsibilities: [
            "Developing customized kernel and operating systems for linux based systems.",
            "Debugging and supporting customers and clients on Radio Unit."
        ],
        link: null,
    },    
    {
        id: 6,
        extra: false,
        title: 'Software Developer Intern',
        company: 'Ericsson',
        started: 'May 2025',
        isCompleted: true,
        ended: 'Dec 2025',
        location: 'Ottawa, ON, Canada',
        workType: 'Coop',
        tags: ['Ottawa', 'Canada', 'Hybrid'],
        tech: ['C#', 'RESTful APIs','Microsoft Azure','AWS','Python','Linux', 'MySQL', 'Git', 'CI/CD', '.NET Framework'],
        responsibilities: [
            "Designed an interactive database dependency visualizer using Python, enabling performance-based decision making.",
            "Developed ETL services in C# (.NET) for large-scale data pipelines, optimizing query performance by 50%.",
            "Migrated database infrastructure to AWS, improving scalability and data throughput.",
            "Collaborated with cloud and API teams to ensure secure and efficient data integration across distributed systems."
        ],
        link: null,
    },    
    {
        id: 1,
        extra: false,
        title: 'System Engineer',
        company: 'Tata Consultancy Services',
        started: 'Jun 2021',
        isCompleted: true,
        ended: 'Apr 2024',
        location: 'Chennai, India',
        workType: null,
        tags: ['Innovation and Research','Full Time'],
        tech: ['C','Docker','Javascript','React.js','Next.js','Angular','Terraform','AWS','Node.js','MongoDB','Python','Azure OpenAI','Tailwind','MySQL'],
        responsibilities: [
            // 'Experimented on NVDIA(Chat with RTX) to try RAG based applications for software documentation files and legal documents.',
            // 'Worked on Mistral and LLama2 open-source models for benchmarking & business poc(s).',
            'Proposed and Built LLM Guard Rails using python, nlp within 2 weeks.',
            'Designed and launched an NLTK based keyword extraction tool, accessible via a REST API.',
            'Built multi-lingual automated communication generator, generates 100K distinct emails.',
            'Created autonomous presentation explainer plugin for humanoid, running without any human intervention throughout the session.',
            'Launched a visualizer cum tracking tool, tracks 200+ annual visits and accessible remotely.',
            'Developed web interfaces for High Performance Computing apps.',
            'Proposed and created workflows for user onboarding',            
            'Built AI-powered tech debt assessment tool, now assessing over 2,000 employees and driving internal improvements.',
            'Mentored junior engineers through pair programming, fostering skill development and knowledge sharing.',
            'Contributed to team culture by leading initiatives in hiring, onboarding, and mentoring.'
        ],
        link: null,
    },
    {
        id: 4,
        extra: false,
        title: 'Software Developer Intern',
        company: 'Tata Consultancy Services',
        started: 'Feb 2020',
        isCompleted: true,
        ended: 'Jun 2020',
        location: 'Chennai, India',
        workType: null,
        tags: ['Internship'],
        tech: ['HTML5','CSS','Bootstrap','JavaScript', 'Git','Java','Python'],
        responsibilities: [
            'Played a team role to develop front-end of a web application using HTML and CSS.',
            'Corrected the flaws on an old website and proposed a new design and succeeded on developing it and built an interface to support edge server metrics.',
            'Made research on HTML UI and created custom web components using bootstrap framework. Contributed to the no-code internal software team.'
        ],
        link: null,
        image: './tcs-intern.jpeg',
    },
    
    
]

function Experience() {

    const [data, setData] = useState(eData)

  return (
    <div className='w-full lg:w-[60%] mx-auto min-h-screen py-8 lg:py-10 px-6 lg:px-20 relative overflow-y-auto'>
        <SideBar />
        <div className='w-full py-4 flex flex-col items-center'>
            {
                data
                ?.map(item => (
                    <ExperienceItem
                        key={item?.id}
                        {...item}
                    />
                ))
            }
        </div>
        <p onClick={() => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }} className='w-full text-right py-2 text-sm underline text-black cursor-pointer'>Back to top</p>
    </div>
  )
}

export default Experience